var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"72px"}},[_c('a-progress',{attrs:{"showInfo":false,"percent":_vm.percent,"strokeColor":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }